module.exports = __webpack_public_path__ + "static/img/theme_list_bg.435d5a63.svg";